import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3276">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3277">
        <div data-id="element-3278">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3279">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3280">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3281">
          <Card className="p-6" data-id="element-3282">
            <div className="flex items-center gap-4" data-id="element-3283">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3284">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3285" />
              </div>
              <div data-id="element-3286">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3287">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3288">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3289">
            <div className="flex items-center gap-4" data-id="element-3290">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3291">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3292" />
              </div>
              <div data-id="element-3293">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3294">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3295">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3296">
            <div className="flex items-center gap-4" data-id="element-3297">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3298">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3299" />
              </div>
              <div data-id="element-3300">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3301">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3302">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3303">
            <div className="flex items-center gap-4" data-id="element-3304">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3305">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3306" />
              </div>
              <div data-id="element-3307">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3308">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3309">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3310">
          <div className="p-6 border-b border-gray-200" data-id="element-3311">
            <h2 className="font-bold text-gray-900" data-id="element-3312">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3313">
            <table className="w-full text-left text-sm" data-id="element-3314">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3315">
                <tr data-id="element-3316">
                  <th className="px-6 py-4 font-medium" data-id="element-3317">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3318">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3319">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3320">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3321">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3322">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3323">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3324">
                {loading ? <tr data-id="element-3325">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3326">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3327">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3328">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3329">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3330">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3331">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3332">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3333">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3334">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3335">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3336">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3337">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}